import isEmpty from "lodash/isEmpty.js";
import { TaskGroups } from "@/modules/tasks/tasks.config.js";
import { EntityParamValue } from "@/modules/tasks/task-value/entities/EntityParamValue.js";
import { TaskDefaultValue } from "@/modules/tasks/task-value/TaskDefaultValue.js";
import { EntitySymptomValue } from "@/modules/tasks/task-value/entities/EntitySymptomValue.js";
import { EntityReminderValue } from "@/modules/tasks/task-value/entities/EntityReminderValue.js";

export class TaskValueFactory {
  #entities = new Map();

  constructor() {
    this.#entities.set(TaskGroups.param, EntityParamValue);
    this.#entities.set(TaskGroups.symptom, EntitySymptomValue);
    this.#entities.set(TaskGroups.reminder, EntityReminderValue);
  }

  /**
   * @param {string} type
   * @param {string} date
   * @param {Object} data
   * @returns {Object}
   */
  build(type, date, data) {
    if (!this.#entities.has(type)) {
      console.error(`Тип ${type} не найден!`);
      return new TaskDefaultValue();
    }

    if (isEmpty(data)) {
      return new TaskDefaultValue(date);
    }

    return new (this.#entities.get(type))(date, data);
  }
}
